import { render, staticRenderFns } from "./VDesigningFormGroups.vue?vue&type=template&id=6f3a8a09&"
import script from "./VDesigningFormGroups.vue?vue&type=script&lang=ts&"
export * from "./VDesigningFormGroups.vue?vue&type=script&lang=ts&"
import style0 from "./VDesigningFormGroups.vue?vue&type=style&index=0&id=6f3a8a09&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports